/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {
    SET_EMBED_PLACEMENT,
    TOGGLE_ADD_ON_ITEM,
    SET_ADS,
    SET_VIDEO_ADS,
    SET_EMBED_PROPERTY,
    SET_PARTNER_LOGO_SRC,
    SET_PARTNER_LOGO_URL,
    TOGGLE_INSTICATOR_BRANDING,
    SET_EMBED_PROPERTIES,
    RECEIVE_EMBED_DATA,
    RESET_EMBED_STATE,
    SET_EMBED_CREATED_STATUS,
    SHOW_PARTNER_LOGO,
    DISCARD_EMBED_CHANGES,
    SET_EDITING_ADD_ON,
    ATTACH_LABEL,
    REMOVE_LABEL
} from 'state/actions/embedsState/embedManagementState/selected_embed_status';
// utils
import { processFormActions, getFormDefaultState } from '@insticator/insticator-ui'; // iui-utils
import { RECEIVE_EMBED_CODE } from "state/actions/embedsState/embedManagementState/selected_embed_status";






/* ========== ~~~~~~~~~~ EMBEDS STATE > EMBED MANAGEMENT STATE > SELECTED EMBED STATUS: REDUCER ~~~~~~~~~~ ========== */
// REDUCER
// used to manipulate application state
// takes an action, checks its type, based on that performs certain functionality, then returns new slice of state
// utilized in "_container" components


// EMBED NAME FORM DATA TRANSPILER
const transpileEmbedNameData = (data) => ({
    embedname: { value: !!data.embedName ? data.embedName : '', valid: !!data.embedName ? true : null }, // valid: null / true / false
    website: { value: !!data.siteUUID ? data.siteUUID : '', valid: !!data.siteUUID ? true : null }
});

// SELECTED EMBED DATA TRANSPILER
const _formEmbedData = (embedData={}) => ({
    // embedNameForm: getFormDefaultState(transpileEmbedNameData, embedData), // EDIT EMBED NAME FORM DATA
    embedUUID: !!embedData.embedUUID ? embedData.embedUUID : null,
    isNewEmbedFlow: !embedData.embedUUID,
    embedChangeDetected: false,
    isSavingData: false,
    contentOrder: !!embedData.contentOrder ? embedData.contentOrder.toLowerCase() : 'ordered',
    location: !!embedData.embedPosition ? (embedData.embedPosition === 'RAIL' ? 'rail' : 'in-content') : null,
    partnerLogo: {
        src: !!embedData.partnerLogoUrl ? embedData.partnerLogoUrl : null,
        url: !!embedData.logoClickThroughUrl ? embedData.logoClickThroughUrl : null },
    showPartnerLogo: typeof embedData.showPartnerLogo !== 'undefined' ? embedData.showPartnerLogo : true,
    brandColor: !!embedData.brandColorCode ? embedData.brandColorCode : '#092e77',
    showInsticatorBranding: typeof embedData.showInsticatorBranding !== 'undefined' ? embedData.showInsticatorBranding : true,
    ads: {
        desktop: _getAdsPositions(!!embedData.webAdDisplayMode ? embedData.webAdDisplayMode : 'REGULAR'),
        mobile: _getAdsPositions( !!embedData.mobileAdDisplayMode ? embedData.mobileAdDisplayMode : 'REGULAR'),
        video: { desktop: !!embedData.showVideoAdForDesktop, mobile: !!embedData.showVideoAdForMobile }
    },
    revenue: {
        marketResearch: typeof embedData.showMarketResearch !== 'undefined' ? !!embedData.showMarketResearch : false,
        profilingQuestions: false,
        rewards: typeof embedData.showRewards !== 'undefined' ? embedData.showRewards : true
    },
    showUserDataCollection: embedData.showUserDataCollection,
    siteUUID: !!embedData.siteUUID ? embedData.siteUUID : null,
    siteURL: !!embedData.siteUrl ? embedData.siteUrl : !!embedData.siteURL ? embedData.siteURL : null,
    embedName: !!embedData.embedName ? embedData.embedName : null,
    attachedLabelUUIDs: !!embedData.attachedLabelUUIDs ? embedData.attachedLabelUUIDs : [],
    headerCode: '',
    bodyCode: '',
});



/* ++++++++++ --------------- CUSTOM METHODS --------------- ++++++++++ */

const _adjustAds = (location, overlay) => {
    switch (location) {
        case 'in-content':
            return { ad1: true, ad2: true, overlay };
        case 'rail':
            return { ad1: true, ad2: !overlay, overlay };
        default:
            return { ad1: true, ad2: true, overlay: false };
    }
};

const _getAdsPositions = adsDisplayMode => {
    switch (adsDisplayMode) {
        case 'REGULAR':
            return { ad1: true, overlay: false, ad2: true };
        case 'OVERLAY_TOP_AD':
            return { ad1: false, overlay: true, ad2: true };
        case 'OVERLAY_BOTTOM_AD':
            return { ad1: true, overlay: true, ad2: false };
        case 'BOTH_OVERLAY_ADS':
            return { ad1: true, overlay: true, ad2: true };
        case 'BOTH_BOTTOM_ADS':
            return { ad1: true, overlay: false, ad2: true };
        default:
            return { ad1: false, overlay: false, ad2: false };
    }
};

//-=-=-=-=-=-=-=-=-=-=-= Default State -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=//

const defaultState = {
    editembedname: getFormDefaultState(transpileEmbedNameData),
    selectedEmbedData: _formEmbedData(),
    editingAddOn: null
};

var previousState = defaultState;

const transpilerSelector = (formName) => {
    switch (formName) {
        case 'editembedname':
            return transpileEmbedNameData;
        default:
            return null;
    }
};

const assignedForms = Object.keys(defaultState);

const selectedEmbedStatus = (state = defaultState, action) => {
    if (action.type.startsWith('FORM_') && assignedForms.includes(action.formName)) {
        return processFormActions(state, action, action.formName, transpilerSelector(action.formName))
    }
    let newState = JSON.parse(JSON.stringify(state));
    switch (action.type) {
        case SET_EMBED_CREATED_STATUS:
            newState.selectedEmbedData.bodyCode = action.status.bodyCode;
            newState.selectedEmbedData.headerCode = action.status.headerCode;
            newState.selectedEmbedData.embedChangeDetected = false;
            newState.selectedEmbedData.isSavingData = false;
            newState.editingAddOn = null;
            previousState = JSON.parse(JSON.stringify(newState));
            return newState;
        case SET_EMBED_PROPERTY:
            newState.selectedEmbedData[action.property] = action.value;
            newState.selectedEmbedData.embedChangeDetected = true;
            return newState;
        case SET_EMBED_PROPERTIES:
            for (let property of Object.keys(action.properties)) {
                newState.selectedEmbedData[property] = action.properties[property];
            }
            newState.selectedEmbedData.embedChangeDetected = true;
            return newState;
        case SET_EMBED_PLACEMENT:
            newState.selectedEmbedData.location = action.placement;
            if (state.selectedEmbedData.location === action.placement) { return newState; }
            newState.selectedEmbedData['ads']['desktop'] = _adjustAds(action.placement, newState.selectedEmbedData.ads.desktop.overlay);
            newState.selectedEmbedData['ads']['mobile'] = _adjustAds('rail', newState.selectedEmbedData.ads.mobile.overlay);
            newState.selectedEmbedData.embedChangeDetected = true;
            return newState;
        case SET_ADS:
            action.mobile ? newState.selectedEmbedData.ads.mobile =
                { ad1: action.ad1, ad2: action.ad2, overlay: action.overlay } :
                newState.selectedEmbedData.ads.desktop = { ad1: action.ad1, ad2: action.ad2, overlay: action.overlay };
            newState.selectedEmbedData.embedChangeDetected = true;
            return newState;
        case SET_VIDEO_ADS:
            newState.selectedEmbedData.ads.video[action.device] = action.value
            newState.selectedEmbedData.embedChangeDetected = true;
            return newState;
        case TOGGLE_ADD_ON_ITEM:
            newState.selectedEmbedData[action.itemToToggle] = !newState.selectedEmbedData[action.itemToToggle]; // toggle whether ad is turned on or off
            newState.selectedEmbedData.embedChangeDetected = true;
            return newState;
        case SET_EDITING_ADD_ON:
            newState.editingAddOn = action.addOn;
            return newState;
        case SET_PARTNER_LOGO_SRC:
            newState.selectedEmbedData.partnerLogo.src = action.logoSource;
            newState.selectedEmbedData.embedChangeDetected = true;
            return newState;
        case SET_PARTNER_LOGO_URL:
            newState.selectedEmbedData.partnerLogo.url = action.url;
            newState.selectedEmbedData.embedChangeDetected = true;
            return newState;
        case RECEIVE_EMBED_DATA:
            newState.selectedEmbedData = _formEmbedData(action.embedData);
            newState.editingAddOn = null;
            previousState = JSON.parse(JSON.stringify(newState));
            return newState;
        case RESET_EMBED_STATE:
            newState.selectedEmbedData = _formEmbedData(action.initialEmbedData);
            previousState = JSON.parse(JSON.stringify(newState));
            return newState;
        case SHOW_PARTNER_LOGO:
            newState.selectedEmbedData.showPartnerLogo = action.bool;
            newState.selectedEmbedData.embedChangeDetected = true;
            return newState;
        case TOGGLE_INSTICATOR_BRANDING:
            newState.selectedEmbedData.showInsticatorBranding = !newState.selectedEmbedData.showInsticatorBranding;
            newState.selectedEmbedData.embedChangeDetected = true;
            return newState;
        case DISCARD_EMBED_CHANGES:
            return previousState;
        case RECEIVE_EMBED_CODE:
            newState.selectedEmbedData.bodyCode = action.code.bodyCode;
            newState.selectedEmbedData.headerCode = action.code.headerCode;
            return newState;
        case ATTACH_LABEL:
            newState.selectedEmbedData.attachedLabelUUIDs.push(action.labelUUID);
            return newState;
        case REMOVE_LABEL:
            newState.selectedEmbedData.attachedLabelUUIDs = newState.selectedEmbedData.attachedLabelUUIDs.filter(labelUUID => labelUUID !== action.labelUUID);
            return newState;
        default:
            return state;
    }
};


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default selectedEmbedStatus;
